"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const PsnRegionBlocked = styled_components_1.default.span `
    font-weight: bold;
    font-size: 1.4em;
    color: yellow;
    font-family: BurbankBigRegular-Black, sans-serif;
    text-transform: uppercase;
`;
exports.default = PsnRegionBlocked;
//# sourceMappingURL=RedeemSectionPsnRegionBlocked.js.map